import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./authenticatedContainer.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import * as NProgress from 'nprogress';
import equalityFn from 'zustand/shallow';
import { headerStore, selectShowSubmenu } from '~/modules/stores/headerStore';
import { i18nStore } from '~/modules/stores/i18nStore';
import { navigate, routerStore } from '~/modules/stores/routerStore';
import { DEFAULT_LANGUAGE_CODE } from '~/modules/utilities/language';
import { upsertQueryParam } from '~/modules/utilities/routingUtilities';
NProgress.configure({
  minimum: 0.2,
  showSpinner: false,
  trickleSpeed: 150
});
class AuthenticatedContainer extends LightningElement {
  constructor(...args) {
    super(...args);
    // bound to x-lazy child template via lwc:dynamic attribute
    this.url = void 0;
    this.pageComponent = void 0;
    this.containerCssClass = 'container';
    this.isLoading = false;
  }
  showSubmenuUpdated(showSubmenu) {
    this.containerCssClass = showSubmenu ? 'container sub-menu-open' : 'container';
  }
  async setPageComponent({
    url,
    queryString,
    pageComponent,
    isLoading
  }) {
    this.isLoading = isLoading;
    const params = new URLSearchParams(queryString);
    const langParam = params.get('lang');
    const userLanguage = DEFAULT_LANGUAGE_CODE; // We are only supporting the default language for now. In the future we should use: langParam || getUserLanguage();
    // Check if there should be a langParam set
    if (userLanguage !== DEFAULT_LANGUAGE_CODE) {
      if (i18nStore.getState().currentLanguage !== userLanguage) {
        await i18nStore.setLanguage(userLanguage);
      }
      if (!langParam) {
        navigate(`/${url}?${upsertQueryParam('lang', userLanguage)}`);
        return;
      }
    } else {
      await i18nStore.setLanguage(DEFAULT_LANGUAGE_CODE);
    }
    this.pageComponent = pageComponent;
    if (this.isLoading) {
      // Only show page loading indicator if URL changed
      if (url !== this.url) {
        this.url = url;
        NProgress.start();
      }
    } else {
      NProgress.done();
      NProgress.remove();
    }
  }
  get isLoadingClass() {
    return this.isLoading ? 'slds-hide' : '';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(AuthenticatedContainer, {
  wire: {
    showSubmenuUpdated: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: headerStore,
          selector: selectShowSubmenu
        };
      }
    },
    setPageComponent: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: routerStore,
          selector: state => ({
            url: state.url,
            queryString: state.queryString,
            pageComponent: state.pageComponent,
            isLoading: state.isLoading
          }),
          equalityFn
        };
      }
    }
  },
  fields: ["url", "pageComponent", "containerCssClass", "isLoading"]
});
const __lwc_component_class_internal = _registerComponent(AuthenticatedContainer, {
  tmpl: _tmpl,
  sel: "page-authenticated-container",
  apiVersion: 62
});
export default __lwc_component_class_internal;